import { z } from 'zod';
import { FlowProducedType } from '../../../flowRun/producedType.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export const FlowDocumentSearchBlockConfigSchema = z.object({
    searchQuery: z.string(),
});
export const FlowDocumentSearchBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.DocumentSearch),
    config: FlowDocumentSearchBlockConfigSchema,
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.Any),
});
//# sourceMappingURL=config.js.map